import { Params, RedirectFunction, Route } from '@angular/router';
import { isPlatformUser } from './core/auth/jwt-claims';
import { PATHS } from './shared/utils/paths';

/**
 * SA-24: platform pages that used to be routed in the company workspace (/dashboard). Nothing links to them any more;
 * an old address or bookmark sends a platform member to the same page in the console and a company user to their home.
 * The company's own pages with similar names stay: settings (Company Settings), :id/Users, :id/branches, :id/financial-years.
 */
export const LEGACY_PLATFORM_PAGES: { path: string; console: (params: Params) => string }[] = [
  { path: PATHS.COMPANY_MANGMENT, console: () => 'tenancy/companies' },
  { path: ':id/FinancialYears', console: (p) => `tenancy/companies/${p['id']}/FinancialYears` },
  { path: ':id/:name/branches', console: (p) => `tenancy/companies/${p['id']}/${p['name']}/branches` },
  { path: ':id/Subscription', console: (p) => `tenancy/companies/${p['id']}/Subscription` },
  { path: ':id/SubscriptionPlan', console: () => 'tenancy/plans' },
  { path: PATHS.SUBSCRIPTION_PLAN, console: () => 'tenancy/plans' },
  { path: PATHS.Subscription_nvoice, console: () => 'tenancy/invoices' },
  { path: PATHS.VOUCHER_TYPES, console: () => 'settings/voucher-types' },
  { path: PATHS.RELIGION_MANAGMENT, console: () => 'settings/religions' },
];

export function legacyPlatformRedirect(page: (typeof LEGACY_PLATFORM_PAGES)[number]): RedirectFunction {
  return ({ params }) =>
    isPlatformUser() ? `/${PATHS.SUPER_ADMIN_ROOT}/${page.console(params)}` : `/dashboard/${PATHS.Homepage}`;
}

export const LEGACY_PLATFORM_ROUTES: Route[] = LEGACY_PLATFORM_PAGES.map((page) => ({
  path: page.path,
  pathMatch: 'full',
  redirectTo: legacyPlatformRedirect(page),
}));
